<template>
    <div>
        <div class="header fixed-top d-flex shadow">
            <div class="side-header d-flex" @click="countries" style="cursor: pointer;">
                <icon :name="'icon-' + countryCode" :width="'25px'" :height="'60%'" :iconColor="'#F8F9FA'"
                    class="my-auto ms-4" />
                <span class="fs-4 fw-semibold mx-3 my-auto text-light"> {{ $t(countryCode) }}</span>
            </div>
            <div class="map-header bg-light d-flex justify-content-end">
                <div class="d-flex justify-content-end mx-5  my-auto">
                    <!-- TODO -->
                    <!-- <button class="btn d-inline-flex align-items-center rounded border-0 px-0 mx-4" disabled>
                        Tutorial
                    </button> -->
                    <button class="btn d-inline-flex align-items-center rounded border-0 px-0 mx-4" @click="countries">
                        <!-- <span class="bi bi-globe" style="margin-right: 8px"></span> -->
                        <span>Change country</span>
                    </button>
                    <!-- TODO -->
                    <!-- <button v-if="fakeData" class="btn d-inline-flex align-items-center rounded border-0 px-0 mx-4"
                        @click="countries">
                        Statistics
                    </button> -->
                    <!-- <button class="btn d-inline-flex align-items-center rounded border-0 px-0 mx-4" @click="logout">
                        <span class="bi bi-box-arrow-right" style="margin-right: 8px"></span>
                        <span>Logout</span>
                    </button> -->
                </div>
            </div>
        </div>
        <div class="content d-flex">
            <aside class="bg-light shadow">
                <div class="sidebar p-3 bg-light">
                    <ul class="list-unstyled ps-0">
                        <div class="border border-secondary border-opacity-75 rounded mt-2 mb-3">
                            <li id="white-spots" class="">
                                <button data-bs-toggle="collapse" data-bs-target="#white-spots-collapse"
                                    aria-expanded="false"
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0 mt-1 collapsed">
                                    White spots
                                </button>
                                <div id="white-spots-collapse" class="collapse" style="">
                                    <div class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <form>
                                            <div class="form-group mb-2">
                                                Fill out the form to detect the settlements in white spots.
                                            </div>
                                            <div class="form-group mb-1">
                                                <label for="">Minimum population :</label>
                                                <input type="number" id="whiteSpotPop" style="width: 90%"
                                                    placeholder="3000" v-model="whiteSpotPop">
                                            </div>
                                            <div class="form-group mb-2">
                                                <label for="">Minimum distance to agent (m) :</label>
                                                <input type="number" id="whiteSpotDist" style="width: 90%"
                                                    placeholder="5000" v-model="whiteSpotDist">
                                            </div>
                                            <div class="form-group my-1">
                                                <button type="button" class="btn btn-primary" id="searchWhiteSpots"
                                                    @click="handleWhiteSpots" style="width: 90%">
                                                    <span class="bi bi-search" style="margin-right: 8px"></span>
                                                    <span>Search</span>
                                                </button>
                                            </div>
                                            <div class="form-group mb-1">
                                                <button type="button" class="btn btn-outline-primary"
                                                    id="resetWhiteSpots" @click="handleWhiteSpots"
                                                    :disabled="whiteSpotLayer == null" style="width: 45%; font-size: 14px;">
                                                    <i class="bi bi-arrow-clockwise"></i> Reset
                                                </button>
                                                <button type="button" class="btn btn-outline-primary mx-1"
                                                    id="exportWhiteSpots" @click="handleWhiteSpots"
                                                    :disabled="whiteSpotLayer == null" style="width: 45%; font-size: 14px;">
                                                    <i class="bi bi-download"></i> Export
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </li>
                            <li id="agents" class="mb-2">
                                <button data-bs-toggle="collapse" data-bs-target="#agents-collapse"
                                    aria-expanded="false"
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0 mt-1 collapsed">
                                    Agents
                                </button>
                                <div id="agents-collapse" class="collapse">
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check form-switch">
                                                    <input type="checkbox" class="form-check-input" role="switch"
                                                        id="agentsIsCheckAll" @change="checkAllAgentsLayer"
                                                        v-model="agentsIsCheckAll">
                                                    <label for="agentsIsCheckAll" class="form-check-label">
                                                        Select all
                                                    </label>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small"
                                        v-for="filterBlock in availableFilters.agents" :key="filterBlock.filter_key">
                                        <a class="link-dark d-inline-flex text-decoration-none rounded"><b>
                                                {{ $t(filterBlock.filter_key) }}
                                            </b></a>
                                        <li v-for="filter in filterBlock.data" :key="filter">
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check form-switch">
                                                    <input type="checkbox" class="form-check-input" role="switch"
                                                        :id="filter" :value="filter" @change="updateAgentsLayer"
                                                        v-model="filterBlock.value">
                                                    <label :for="filter" class="form-check-label">
                                                        {{ $t(filter) }}
                                                    </label>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- TODO : add "Filters on transaction" (filter-transac) here -->
                                </div>
                            </li>
                            <li class="mx-3 d-flex mb-1">
                                <img class="fit-picture me-2 my-auto" src="../assets/img/icons/IconInfo.svg"
                                    alt="-info-" height="15">
                                <p class="info mb-1 lh-sm"><b>White spots</b> and <b>Agents</b> are exclusive: using one
                                    will disable the other </p>
                            </li>
                        </div>
                        <div class="border border-secondary border-opacity-75 rounded mt-1 mb-3">
                            <li id="coverage" class="mb-1">
                                <button data-bs-toggle="collapse" data-bs-target="#coverage-collapse"
                                    aria-expanded="false"
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0 mt-1 collapsed">
                                    Coverage
                                </button>
                                <div id="coverage-collapse" class="collapse">
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" id="0G" value="-1"
                                                        v-model="covSelected">
                                                    <label for="0G" class="form-check-label">None</label>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-for="(item, index) in [2, 3, 4]" :key="item">
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" :id="item + 'G'"
                                                        :value="index" v-model="covSelected">
                                                    <label :for="item + 'G'" class="form-check-label"> {{ item
                                                    }}G</label>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check">
                                                    <!-- <label class="form-check-label"> Opacitty : {{ covOpacity }}</label> -->
                                                    <Slider v-model="covOpacity" :min="0" :max="100" />
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </div>
                        <div class="border border-secondary border-opacity-75 rounded mt-1 mb-3">
                            <li id="adm" class="mb-1">
                                <button data-bs-toggle="collapse" data-bs-target="#adm-collapse" aria-expanded="false"
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0 mt-1 collapsed">
                                    Regional indicators
                                </button>
                                <div id="adm-collapse" class="collapse">
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small"
                                        v-for="filterBlock in availableFilters.adm" :key="filterBlock.filter_key">
                                        <li>
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" id="null-filter"
                                                        :value="null" @change="updateRegionalFilters"
                                                        v-model="filterBlock.value">
                                                    <label for="null-filter" class="form-check-label">
                                                        None
                                                    </label>
                                                </div>
                                            </a>
                                        </li>
                                        <li v-for="filter in filterBlock.data" :key="filter">
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" :id="filter"
                                                        :value="filter" @change="updateRegionalFilters"
                                                        v-model="filterBlock.value">
                                                    <label :for="filter" class="form-check-label">
                                                        {{ $t(filter) }}
                                                    </label>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </div>
                        <div class="border border-secondary border-opacity-75 rounded mt-1 mb-3">
                            <li id="population" class="mb-1">
                                <button data-bs-toggle="collapse" data-bs-target="#population-collapse"
                                    aria-expanded="false"
                                    class="btn btn-toggle d-inline-flex align-items-center rounded border-0 mt-1 collapsed">
                                    Population
                                </button>
                                <div id="population-collapse" class="collapse">
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <a class="link-dark d-inline-flex text-decoration-none rounded">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch"
                                                        id="displayPopTile" v-model="displayPopTile">
                                                    <label class="form-check-label" for="displayPopTile">Display
                                                        population
                                                        tile</label>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </aside>
            <div class="bg-dark map-wrapper">
                <div id="map">
                    <Legend :data="legendData" :border="true" v-if="legendData.length > 0"></Legend>
                </div>
            </div>
        </div>
        <TabbedInfo ref="infos" :title="infoTitle" :values="infoValues" :months="agentDateRange" />
    </div>
</template>

<script>
import TabbedInfo from '@/components/TabbedInfo.vue';
// import VueSlider from 'vue-slider-component'  // TODO : filters on transaction
import Legend from '@/components/Legend.vue';
import Slider from '@/components/Slider';

import L from 'leaflet';
import 'leaflet-hash';
import 'leaflet.fullscreen';
import 'leaflet-basemaps';
import 'leaflet-spin';
import 'leaflet-mouse-position';
import 'leaflet-draw';
import Wkt from 'wicket';
import circle from '@turf/circle'
// import * as d3 from 'd3-format';  // TODO : filters on transaction
import { baseLayers } from '@/util/baseLayers';
import { bboxToWKT } from "@/util/wkt.js";  // TODO : remove and use 'wicket'
// import { startIntro } from '@/util/tutorial.js';  // TODO : tutorial
import { styles, getStyle } from "@/style/layerStyles.js";
import { getSteps, stepsToLegend } from '@/util/legend.js';
import { PruneCluster, PruneClusterForLeaflet } from 'exports-loader?exports[]=PruneCluster&exports[]=PruneClusterForLeaflet!@sintef/prune-cluster/dist/PruneCluster.js';

PruneCluster.Cluster.ENABLE_MARKERS_LIST = true;
delete L.Icon.Default.prototype._getIconUrl;

// make webpack import the marker
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const settIcon = L.icon({
    iconUrl: require('@/assets/img/icons/ico-house-green.svg'),
    iconSize: [40, 40], // size of the icon
    iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
    popupAnchor: [0, -40] // point from which the popup should open relative to the iconAnchor
});

// // TODO : distance to agent
// const distIcon = L.icon({
//     iconUrl: require('@/assets/img/icons/ico-flag-green.svg'),
//     iconSize: [40, 40],
//     iconAnchor: [20, 40],
//     popupAnchor: [0, -40]
// });

// Change and copy options here http://spin.js.org/
const spinOpts = {
    lines: 8, // The number of lines to draw
    length: 38, // The length of each line
    width: 17, // The line thickness
    radius: 45, // The radius of the inner circle
    scale: 0.5, // Scales overall size of the spinner
    corners: 1, // Corner roundness (0..1)
    speed: 1.2, // Rounds per second
    rotate: 0, // The rotation offset
    animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: '#ffffff', // CSS color or array of colors
    fadeColor: 'transparent', // CSS color or array of colors
    top: '50%', // Top position relative to parent
    left: '50%', // Left position relative to parent
    shadow: '0 0 1px transparent', // Box-shadow for the lines
    zIndex: 2000000000, // The z-index (defaults to 2e9)
    className: 'spinner', // The CSS class to assign to the spinner
    position: 'absolute', // Element positioning
};

const emptyTile = 'https://tileserver.masae-analytics.com/raster/256x256_transparent.png';

// // TODO : distance to agent
// const formatPrefix = d3.format(',.2s');

const tileLayerOptions = {
    maxNativeZoom: 12,
    maxZoom: 19,
    tms: true,
    errorTileUrl: emptyTile
};
const worldPoly = [[[180, -90], [180, 90], [-180, 90], [-180, -90]]];

export default {
    name: 'Map',
    props: {
        'countryCode': String,
    },
    components: {
        Legend, TabbedInfo, Slider  //, VueSlider  // filters on transac
    },
    data() {
        return {
            enabledMode: null,
            currentProp: '',
            choices: [],
            form: '',
            infoTitle: null,
            infoValues: {},
            vw: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
            covSelected: -1,
            covOpacity: 20,
            agentsInRange: null,
            displayedAgents: 0,
            agentDisplayedFields: [],
            agentFilterSelected: null,
            agentSliderDates: [],
            agentsSliderMarks: [],
            agentDateRange: null,
            agentValueRange: [],
            agentSliderValues: [],
            loading: false,
            availableFilters: {},
            agentsIsCheckAll: false,
            whiteSpotPop: 3000,
            whiteSpotDist: 5000,
            whiteSpotLayer: null,
            agentsLayer: null,
            coverageLayers: null,
            admLayer: null,
            legendData: [],
            displayPopTile: false,
            popTile: null,
            fakeData: false,
            drawnCoords: null,
        }

    },

    created() {
        this.popTileURL = `https://tileserver.masae-analytics.com/raster/CICO_${this.countryCode.toUpperCase()}_HRSL/{z}/{x}/{y}.png`;
        // this.nbFormatter = d3.format(',.0f');  // TODO : distance to agent
        this.modeLayers = L.layerGroup();
    },

    mounted() {
        // get config
        import(`../../../country_config/${this.countryCode}.json`).then(config => {
            this.config = config.default;
            this.agentsSliderChoices = null;
            if (config.cico_months) {
                this.agentsSliderChoices = {
                    'tot-cash-in': 'ci',
                    'tot-cash-out': 'co',
                    'ratio': 'ratio',
                };
                this.agentFilterSelected = Object.values(this.agentsSliderChoices)[0];
            }
            this.initMap();
        }).finally(() => {
            this.loadRegions();
            this.loadAgents();
            // // TODO : tutorial
            // this.startIntro();
        });
    },

    methods: {
        initMap() {
            this.map = L.map('map', {
                zoomControl: true,
                maxZoom: 19,
                minZoom: 5,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    forceSeparateButton: true,
                },
                center: this.config.center,
                zoom: this.config.zoom,
            });
            // drawing tools
            this.drawnItems = new L.FeatureGroup();
            this.map.addLayer(this.drawnItems);
            const drawControlFull = new L.Control.Draw({
                draw: {
                    polyline: false,
                    marker: false,  // TODO : distance to agent
                    circlemarker: false,
                },
                edit: {
                    featureGroup: this.drawnItems,
                    edit: false,
                    remove: false,
                }
            });
            const drawControlEditOnly = new L.Control.Draw({
                draw: false,
                edit: {
                    featureGroup: this.drawnItems,
                }
            });
            this.map.addControl(drawControlFull);
            this.map.on('draw:created', (e) => {
                this.drawnItems.addLayer(e.layer);
                this.map.removeControl(drawControlFull);
                this.map.addControl(drawControlEditOnly);
            });
            this.map.on("draw:deleted", () => {
                this.map.removeControl(drawControlEditOnly);
                this.map.addControl(drawControlFull);
            });
            // layers
            import(`@/assets/layers/${this.countryCode}.json`).then(poly => {
                if (poly.geometries) poly.geometries[0].coordinates.unshift(worldPoly); // invert polygon
                else poly.geometry.coordinates.unshift(worldPoly);
                const inverted = L.geoJson(poly, styles['countryMask']);
                inverted.addTo(this.map);
            });
            this.defaultCursor = this.map._container.style.cursor;
            new L.Hash(this.map);
            this.$modal.show('data-modal');
            this.initLayers();
            this.map.on("popupopen", function (e) {
                setTimeout(() => { e.popup.update(); }, 0);
            });
            this.modeLayers.addTo(this.map);
        },

        initLayers() {
            this.map.createPane('above');
            this.coverageLayers = [2, 3, 4].map(type => {
                const url = `https://tileserver.masae-analytics.com/raster/CICO_${this.countryCode.toUpperCase()}_${type}G_COV/{z}/{x}/{y}.png`;
                return L.tileLayer(url, { ...tileLayerOptions, opacity: this.covOpacity / 100, pane: 'above' });
            });
            this.popTile = L.tileLayer(this.popTileURL, { ...tileLayerOptions, opacity: this.config.hrsl_opacity });
            const baseMaps = L.control.basemaps({
                basemaps: baseLayers,
                position: 'bottomleft',
            });
            L.control.mousePosition({
                position: 'bottomleft',
                separator: ', ',
                emptyString: 'Mouse coords',
                lngFirst: true,
                numDigits: 4,
                prefix: 'Lng, Lat: '
            }).addTo(this.map);
            this.map.addControl(baseMaps);
        },

        // // TODO : tutorial
        // startIntro() { startIntro(false); },

        initTool(mode, func = null, pointerType = null) {
            this.clearLayers();
            this.choices = [];
            this.displayedAgents = 0;
            this.form = '';
            this.agentDateRange = null;
            this.$refs.infoPanel.$el.classList.remove('closed');
            if (pointerType) this.map._container.style.cursor = pointerType;
            else this.map._container.style.cursor = this.defaultCursor;
            if (this.enabledMode == mode) {
                // uncheck radio buton
                document.getElementById(this.enabledMode).children[0].checked = false;
                this.map._container.style.cursor = this.defaultCursor;
                this.enabledMode = null;
                return;
            }
            this.enabledMode = mode;
            if (func) func();
        },
        // distance() {
        //     this.initTool('distance', null, 'pointer');
        //     this.form = 'FormAgentsDistance';
        //     if (this.enabledMode == 'distance')
        //         this.$toast.info('Click on the map to get the distance to the closest agent');
        // },
        // correlations() {
        //     this.$modal.show('correlations');
        // },
        // flow() {
        //     this.$modal.show('flow');
        // },
        countries() {
            this.$router.push('countries');
        },
        // handleSubmit(formData) {
        //     if (this.enabledMode == 'white-spots') this.displayWhiteSpots(formData)
        //     else if (this.enabledMode == 'distance') this.maxDistAgent = formData.maxDistAgent;
        // },
        // 
        // onMapClick(clickEvent) {
        //     const lat = clickEvent.latlng.lat;
        //     const lng = clickEvent.latlng.lng;
        //     switch (this.enabledMode) {
        //         case 'distance':
        //             this.distanceRequest(lng, lat);
        //             break;
        //     }
        // },
        logout() { this.$logout(); },

        layerFromResponse(layerData, style, onEachFeature = null) {
            const params = { style: style };
            if (onEachFeature != null) params.onEachFeature = onEachFeature;
            const layer = L.geoJSON(layerData, params)
            return layer;
        },

        loadRegions() {
            this.$axios.get('/adm', {
                params: {
                    ccode: this.countryCode,
                    level: 2,
                }
            }).then((response) => {
                this.setupFilters(response.data.filters, 'adm');
                const data = response.data.adm;
                this.admLayer = this.layerFromResponse(data, styles.settContour);
                this.map.addLayer(this.admLayer);
                this.updateRegionalFilters();
            })
            // hotfix for users connected before `user_id` was added to flask session
            .catch(error => {
                if (error.response.status == 401) {
                // if (error.response.data == "Please login") {
                    this.logout();
                }
            });
        },

        loadAgents() {
            this.loading = true;
            this.map.spin(true, spinOpts);
            this.$axios.get('/agents', {
                params: { ccode: this.countryCode, }
            }).then((response) => {
                this.agentsLayer = new PruneClusterForLeaflet();
                this.setupFilters(response.data.filters, 'agents');
                response.data.agents.forEach(agent => {
                    // loc, business, more?...
                    const latlng = agent.loc.reverse();
                    const marker = new PruneCluster.Marker(latlng[0], latlng[1]);
                    marker.data.infos = {};
                    Object.entries(agent).forEach(([key, value]) => {
                        if (key == 'loc') return;
                        marker.data.infos[key] = value;
                    });
                    this.agentsLayer.RegisterMarker(marker);
                });
                if (this.agentsSliderChoices) {
                    this.initSliders(response.data);
                }
                this.agentsLayer.PrepareLeafletMarker = (marker, data) => {
                    if (Object.keys(data.infos) == 0) return;
                    const values = Object.entries(data.infos).reduce((obj, [key, value]) => {
                        if (!value) return obj;
                        const choices = this.choices.find(c => c.title == key);
                        let label = value;
                        if (choices) label = choices.data.find(v => v.id == value).label;
                        obj[key] = label;
                        return obj;
                    }, {});
                    marker.bindPopup(() => this.setInfos(values));  // FIXME : too big sometimes in Pakistan or DRC
                };
            }).finally(() => {
                this.loading = false;
                this.map.spin(false)
                this.updateAgentsLayer();
                this.map.addLayer(this.agentsLayer);
                this.$toast.success('Data loaded successfully');
            });
        },

        initSliders(data) {
            this.agentDateRange = data.months.map(d => d.replace('_', '-'));
            this.agentsLayer.Cluster._markers.map(marker => {
                marker.data.infos.ratio = marker.data.infos.ci.map((ci, index) => {
                    if (!ci) return 0;
                    if (!marker.data.infos.co[index]) return ci;
                    return ci / marker.data.infos.co[index]
                });
            });
            this.agentsSliderMarks = this.agentDateRange;
            this.agentSliderDates = [this.agentDateRange[0], this.agentDateRange[this.agentDateRange.length - 1]];
            this.updateRangeSliderValue()
        },

        updateRangeSliderValue() {
            const selectedPrefix = this.agentFilterSelected;
            const indexStart = this.agentDateRange.indexOf(this.agentSliderDates[0]);
            const indexEnd = this.agentDateRange.indexOf(this.agentSliderDates[1]);
            this.agentValueRange = [0, Math.max(...this.agentsLayer.Cluster._markers.map(marker => {
                const agent = marker.data.infos;
                const values = agent[selectedPrefix].slice(indexStart, indexEnd + 1);
                const sum = Math.floor(values.reduce((prev, cur) => prev + cur, 0));
                if (['ci', 'co'].includes(selectedPrefix)) return sum;
                return sum / values.length;
            }))];
            this.agentSliderValues = [0, 100];
            this.updateAgentsLayer();
        },

        // return true if current agent should be displayed
        filterAgentValue(marker) {
            const indexStart = this.agentDateRange.indexOf(this.agentSliderDates[0]);
            const indexEnd = this.agentDateRange.indexOf(this.agentSliderDates[1]);
            const selectedPrefix = this.agentFilterSelected;
            const values = marker.data.infos[selectedPrefix].slice(indexStart, indexEnd + 1);
            let valToCompare = values.reduce((prev, cur) => prev + cur, 0);
            if (!(['ci', 'co'].includes(selectedPrefix))) valToCompare /= values.length;
            return valToCompare >= this.agentSliderValuesLog[0] && valToCompare <= this.agentSliderValuesLog[1];
        },

        handleWhiteSpots(clickEvent) {
            // reinit
            this.modeLayers.clearLayers();
            if (this.whiteSpotLayer !== null) {
                this.map.removeLayer(this.whiteSpotLayer);
                this.whiteSpotLayer = null;
            }
            this.legendData = this.legendData.filter(data => data.layerKey != 'marker');
            // if we had to reset, we just stop here
            if (clickEvent.target.id == "resetWhiteSpots") {
                return;
            }
            // else we continue
            // we remove agents layer
            this.agentsIsCheckAll = false;
            this.checkAllAgentsLayer();
            // we calculate white spots
            let bbox = this.map.getBounds();
            bbox = bboxToWKT(bbox);
            if (this.drawnItems.getLayers().length > 0) {
                const layer = this.drawnItems.getLayers()[0];
                let geojson = layer.toGeoJSON();
                if (layer instanceof L.Circle) {
                    const center = [layer._latlng.lng, layer._latlng.lat];
                    const radius = layer._mRadius;
                    const options = { steps: 64, units: 'meters' };
                    geojson = circle(center, radius, options);
                    // TODO : do we want to display the circle on the map, or the polygon ?
                    this.drawnItems.removeLayer(layer);
                    this.drawnItems.addLayer(L.geoJSON(geojson));
                }
                var wkt = new Wkt.Wkt();
                wkt.read(JSON.stringify(geojson.geometry));
                bbox = wkt.write();
            }
            const params = {
                ccode: this.countryCode,
                bbox: bbox,
                pop: this.whiteSpotPop,
                dist: this.whiteSpotDist,
            };
            if (clickEvent.target.id == "exportWhiteSpots") params.export = true;
            this.loading = true;
            this.map.spin(true, spinOpts);
            this.$axios.get('/ws', {
                params: params,
                responseType: params.export ? 'blob' : 'json'
            }).then((response) => {
                if (params.export) {
                    const filename = response.headers['content-disposition'].split("filename=")[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    link.click();
                    window.URL.revokeObjectURL(url);
                    return;
                }
                const setts = new PruneClusterForLeaflet();
                if (response.data.length > 0) {
                    const where = this.drawnItems.getLayers().length > 0 ? "in the drawn area" : "in window view"
                    this.$toast.success(`${response.data.length} settlements found ${where}`);
                } else {
                    this.$toast.error(`No settlement found, please reduce the constrains of the filter`);
                }
                response.data.forEach(sett => {
                    const latlng = sett.point.reverse();
                    const marker = new PruneCluster.Marker(latlng[0], latlng[1]);
                    marker.data.gid = sett.gid;
                    setts.RegisterMarker(marker);
                });
                setts.PrepareLeafletMarker = (marker, data) => {
                    marker.setIcon(settIcon);
                    marker.on('click', () => {
                        console.log("click")
                        this.showSettlement(data.gid);
                    })
                };
                this.whiteSpotLayer = setts;
                this.map.addLayer(this.whiteSpotLayer);
            }).finally(() => {
                this.loading = false;
                this.map.spin(false);
                this.legendData.push({
                    title: "White spots",
                    layerKey: "marker",
                });
            });
        },

        showSettlement(sett_id) {
            this.$axios.get('/show_sett', {
                params: {
                    ccode: this.countryCode,
                    sett_id: sett_id,
                }
            }).then((response) => {
                let data = response.data;
                const settLayer = this.layerFromResponse(data, styles.settContour);
                this.modeLayers.addLayer(settLayer);
                settLayer.bindPopup(() => this.setInfos(data.properties)).openPopup();
                const agentCoords = data.properties.agent_loc.reverse();
                const settCenter = data.properties.centroid.reverse();
                L.marker(agentCoords).addTo(this.modeLayers);
                const line = L.polyline([settCenter, agentCoords], { color: 'black', dashArray: '10', className: 'path-dist' }).addTo(this.modeLayers);
                this.map.fitBounds(settLayer.getBounds().extend(line.getBounds()).pad(0.1));
            });
        },

        // // TODO : distance to agent
        // distanceRequest(lng, lat) {
        //     this.clearLayers();
        //     const point = pointToWKT(lng, lat);
        //     this.$axios.get('/distance', {
        //         params: {
        //             wkt: point,
        //             ccode: this.countryCode,
        //             maxDist: this.maxDistAgent,
        //         }
        //     }).then(response => {
        //         this.agentsInRange = response.data.data;
        //         this.agentDisplayedFields = response.data.displayed_fields;
        //         if (this.agentsInRange.length == 0)
        //             return this.$toast.error(`No agent less than ${formatPrefix(this.maxDistAgent)}m from point. Please try another location or a bigger distance.`)
        //         this.agentMarkers = this.agentsInRange.map((agent, i) => {
        //             agent.dist = formatPrefix(agent.dist) + 'm';
        //             const marker = L.marker(agent.loc.reverse())
        //             marker.on('mouseover', () => { this.$refs.agents[i].classList.add('active') });
        //             marker.on('mouseout', () => { this.$refs.agents[i].classList.remove('active') });
        //             return marker;
        //         });
        //         const group = L.featureGroup(this.agentMarkers);
        //         L.marker([lat, lng], { icon: distIcon }).addTo(group);
        //         const first = this.agentsInRange[0];
        //         const line = L.polyline([[lat, lng], first.loc], { color: 'black', dashArray: '10', className: 'path-dist' })
        //             .bindPopup(`Distance : ${first.dist}`).addTo(group);
        //         this.map.fitBounds(group.getBounds().pad(0.2));
        //         group.addTo(this.modeLayers);
        //         line.openPopup();
        //     }).catch(error => console.log(error));
        // },

        updateAgentsLayer() {
            this.legendData = this.legendData.filter(data => data.layerKey != 'marker');
            // update "Select all" checkbox
            var allChecked = true;
            this.availableFilters.agents.forEach((filterBlock) => {
                allChecked = allChecked && (filterBlock.data.length == filterBlock.value.length)
            })
            this.isCheckAll = allChecked;
            document.getElementById("agentsIsCheckAll").checked = allChecked;
            // update map
            this.displayedAgents = 0;
            this.agentsLayer.Cluster._markers.forEach(marker => {
                let filtered = false;
                this.availableFilters.agents.forEach((filterBlock) => {
                    const filteredKey = filterBlock.filter_key;
                    const selected = filterBlock.value;
                    let filteredNow = false;
                    if (Array.isArray(selected)) filteredNow = !selected.includes(marker.data.infos[filteredKey]);
                    else filteredNow = marker.data.infos[filteredKey] != selected;
                    filtered = filtered || filteredNow;
                });
                // if (this.agentsSliderChoices && !filtered) { filtered = !this.filterAgentValue(marker); }
                if (!filtered) this.displayedAgents += 1;
                marker.filtered = filtered;
            });
            this.agentsLayer.ProcessView();
            if (this.displayedAgents > 0) {
                this.handleWhiteSpots({ target: { id: "resetWhiteSpots" } });
                this.legendData.push({
                    title: "Agents",
                    layerKey: "marker",
                });
            }
        },

        setInfos(data, title = '') {
            this.infoValues = data;
            this.infoTitle = title;
            return this.infos;
        },

        setupFilters(filtersMeta, tool) {
            if (!filtersMeta) filtersMeta = [];
            filtersMeta.forEach(filter => {
                filter.value = filter.exclusive ? null : [];
                delete filter.exclusive;
                if (!filter.filter_key) filter.filter_key = tool;
            });
            this.choices = filtersMeta;
            // TODO : make it more beautiful
            // do we really need such an ugly key to add the `tool` and update the render ?
            if (!(tool in this.availableFilters)) this.availableFilters = { ...this.availableFilters, [tool]: [...filtersMeta] };
        },

        // // TODO : filters on transac
        // toLog(value) {
        //     const max = Math.log(this.agentValueRange[1]);
        //     const scale = max / 100;
        //     return this.nbFormatter(Math.floor(Math.exp(scale * value)));
        // },

        updateRegionalFilters() {
            const selected = this.availableFilters.adm[0].value; // TODO : make it more beautiful
            const values = [];
            this.admLayer.eachLayer(path => { values.push(path.feature.properties[selected]) });
            const steps = getSteps(values, 'adm');
            this.admLayer.eachLayer(path => {
                path.setStyle(getStyle(path, steps, selected, 'adm'));
                path.bindPopup(() => this.setInfos(path.feature.properties));
            });
            this.legendData = this.legendData.filter(data => data.layerKey != 'adm');
            if (steps[0] !== undefined) {
                this.legendData.push(stepsToLegend(steps, 'Regional indicators', 'adm'));
                console.log(this.legendData);
            }
        },

        checkAllAgentsLayer() {
            this.availableFilters.agents.forEach((filterBlock) => {
                filterBlock.value = this.agentsIsCheckAll ? filterBlock.data : []
            });
            this.updateAgentsLayer();
        }

    },
    computed: {
        infos() { return this.$refs.infos.$el; },  // TODO : more beautiful
        // // TODO : agents filter on transac
        // comparisonText() {
        //     let operation = 'sum';
        //     if (!['ci', 'co'].includes(this.agentFilterSelected)) operation = 'mean';
        //     return `
        //         ${this.$t(operation)} ${this.$t('of')} 
        //         <b>${this.$t(this.curTransactionType)}</b> ${this.$t('between')} <br>
        //         <b> ${this.agentSliderDates[0]} </b> 
        //         ${this.$t('and')} 
        //         <b>${this.agentSliderDates[1]}</b>
        //         </span>
        //     `
        // },
        // curTransactionType() {
        //     return Object.keys(this.agentsSliderChoices).find((v) => this.agentsSliderChoices[v] == this.agentFilterSelected);
        // },
        // agentSliderValuesLog() {
        //     const max = Math.log(this.agentValueRange[1]);
        //     const scale = max / 100;
        //     return [
        //         Math.exp(scale * this.agentSliderValues[0]),
        //         Math.exp(scale * this.agentSliderValues[1])
        //     ]
        // }
    },
    watch: {
        // // TODO : agents filter on transac
        // agentFilterSelected(now, before) {
        //     if (before == null) return;
        //     this.updateRangeSliderValue();
        // },
        // agentSliderDates() {
        //     this.updateRangeSliderValue();
        // },
        // agentSliderValues() {
        //     if (this.timeoutId) clearTimeout(this.timeoutId);
        //     this.timeoutId = setTimeout(() => {
        //         this.updateAgentsLayer();
        //     }, 500);

        // },
        covSelected(now, before) {
            if (before != -1) {
                this.map.removeLayer(this.coverageLayers[before]);
                this.legendData = this.legendData.filter(data => data.layerKey != 'coverage');
            }
            if (now != -1) {
                this.map.addLayer(this.coverageLayers[now]);
                this.legendData.push({
                    data: [{ color: "#005bf8", label: "Covered" }],
                    title: "Coverage",
                    layerKey: "coverage",
                });
            }
        },
        covOpacity(now) {
            this.coverageLayers.forEach(l => l.setOpacity(now / 100));
        },
        displayPopTile(now) {
            if (now) {
                this.map.addLayer(this.popTile);
                this.legendData.push({
                    title: "Population",
                    layerKey: "pop",
                });
            } else {
                this.map.removeLayer(this.popTile);
                this.legendData = this.legendData.filter(data => data.layerKey != 'pop');
            }
        }
    },
    // depending on browser, blur sometimes do not occur
    beforeRouteLeave(to, from, next) {
        this.$el.blur();
        next();
    }
}
</script>

<style lang="scss" scoped>
@import '@/style/scss/components/map';
</style>